class ExpandableFAQ extends HTMLElement {
    constructor() {
      super();
      this.detailsContainer = this.querySelectorAll('details');
      this.summaryToggle = this.querySelectorAll('summary');
  
      this.summaryToggle.forEach((summary, index) => {
        summary.addEventListener('click', this.onSummaryClick.bind(this, index));
        summary.setAttribute('role', 'button');
        summary.setAttribute('tabindex', '0');
      });
    }
  
    isOpen(detailElement) {
      return detailElement.hasAttribute('open');
    }
  
    onSummaryClick(index, event) {
      event.preventDefault();
      const targetDetail = this.detailsContainer[index];
      this.isOpen(targetDetail) ? this.close(targetDetail) : this.open(targetDetail);
    }
  
    open(detailElement) {
      detailElement.setAttribute('open', true);
    }
  
    close(detailElement) {
      detailElement.removeAttribute('open');
    }
  }
  
  customElements.define('expandable-faq', ExpandableFAQ);